import { Component, ErrorHandler, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, TitleStrategy } from '@angular/router';
import { Cliente } from 'src/app/model/cliente';
import { TokenStorageServiceCliente } from 'src/app/services/api/TokenStorageServiceCliente';
import { LoginService } from 'src/app/services/api/login.service';
import { ProductoDTOService } from 'src/app/services/api/productoDTO.service';
import { catchError, Observable, of } from 'rxjs';
import { HostListener } from '@angular/core';
@Component({
  selector: 'app-login-cliente',
  templateUrl: './login-cliente.component.html',
  styleUrls: ['./login-cliente.component.css']
})
export class LoginClienteComponent   implements OnInit{
 

  formLoginCliente!: FormGroup;
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  noExisteMovil = false;
  noExisteUsuario = false;
  roles: string[] = [];
  datosCliente:Cliente[]=[];
  codigoClienteDTO?:String="";
  tipoLogeo:number=0;
 rs:string=""
 mostrarPassword:boolean=false;
 numeroMovil:String="";


  constructor(
    private loginService : LoginService,
    private tokenStorage: TokenStorageServiceCliente,
    private router:Router,
    private clienteService:ProductoDTOService,
    private activatedRoute : ActivatedRoute,
   
  ){


    activatedRoute.params.subscribe( prm => {
      console.log(`El id es: ${prm['idTipo']}`);
      this.tipoLogeo=prm['idTipo'];

  })



  }

  ngOnInit(): void {
    this.formLoginCliente = new FormGroup({
      'txtClave' : new FormControl('', Validators.required)
    });


    if (this.tokenStorage.getToken()==null) {
    
   //   this.router.navigateByUrl('/login-cliente/1');
  

    }else {

      this.router.navigateByUrl('/inicio');
    }
  }


  OnRegistraCliente(){
    this.router.navigateByUrl('/registro-cliente/'+this.tipoLogeo);
}

OnIrInicio(){
    this.router.navigateByUrl('/inicio');
}


  onSubmit() {
 
    if (this.formLoginCliente.value['txtClave']!==""){


  //  this.OnBuscarMovil(this.formLoginCliente.value['txtClave']);


this.OnBuscarMovil(this.formLoginCliente.value['txtClave'])+"";



    }
  

    }


  
  

    
     OnBuscarMovil(movil:String){

  //localStorage.removeItem('cliente_stg');



   this.clienteService.getClienteByMovil(movil).subscribe( response =>{
    localStorage.setItem('cliente_stg', JSON.stringify(response));

    if (response.length>0){
  this.noExisteMovil=false;
  for (let datosCliente of response){
     
    this.codigoClienteDTO=datosCliente.codigoCliente
  }
  this.GetRepuesta();



}else {
  this.noExisteMovil=true;
}



    
   }
  );
  






}



OnMostrarPassword(){
  this.mostrarPassword=true;
 this.numeroMovil= this.formLoginCliente.value['txtClave'];
}

GetRepuesta(){


   this.ValidarUsuario(this.codigoClienteDTO);
}



ValidarUsuario(codigocliente:any){

  if (codigocliente!==""){

    this.loginService.login(codigocliente,codigocliente).subscribe(
          data => {
            this.tokenStorage.saveToken(data.accessToken);
            this.tokenStorage.saveUser(data);
            this.isLoginFailed = false;
            this.isLoggedIn = true;
            this.roles = this.tokenStorage.getUser().roles;
           
            //this.reloadPage();

            if (this.tipoLogeo==1){
              this.router.navigateByUrl('/carrito');
              localStorage.setItem('ejecutaCompra','1');
            }

         
            if (this.tipoLogeo==2){
              
              this.router.navigateByUrl('/cambio');
            }

            if (this.tipoLogeo==3){
              
              this.router.navigateByUrl('/pedido-cliente');
            }

          
           
          },
          err => {
         
            this.isLoginFailed = true;
            console.log("No existe cuenta");
      
           
          }
        );
     
  
  }else {
  
       this.isLoginFailed = true;
             console.log("No existe cuenta");
      
         
  
  }
  

}


}
